import { useEffect, useState, useMemo } from 'react';
import { Card, Space, Table, Input, Button, Flex, Select, Divider, Row, Col, Statistic } from 'antd';
import CustomerService from "services/debt"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useNavigate } from 'react-router';
import _ from "lodash"
import AddDebt from "components/debt/AddDebt"
import AddPayment from "components/debt/AddPayment"
import moment from "moment"
import CustomerInfoModal from "components/customer/InfoModal"
const service = new CustomerService();
const { Search } = Input;
const OrderList = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [filter, setFilter] = useState({ info: "" })
    const [clickPhone, setClickPhone] = useState("");
    const [showCustomerInfo, setShowCustomerInfo] = useState(false);
    // useEffect(() => {
    //     loadData({});
    // }, [])

    useEffect(() => {
        delaySearch(filter);
    }, [filter])

    const loadData = async (data) => {
        var lst = await service.customerList(data);
        setData(lst);
    }

    const delaySearch = useMemo(() => _.debounce(loadData, 500), []);

    const onSearch = () => {
        delaySearch({});
    }

    const setFilterValue = (name, value) => {

        var newFilter = { ...filter };
        newFilter[name] = value;
        setFilter(newFilter)
    }
    const updateStats = async (id) => {
        await service.updateStats(id);
        loadData();
    }


    const onSaved = async () => {
        loadData();
    }
    const showCustomer = phone => {
        setClickPhone(phone);
        setShowCustomerInfo(true);
    }

    const columns = [
        {
            title: 'Khách hàng',

            render: (record) => {

                return (
                    <Space direction='vertical'>
                        <Button type='text' onClick={e => showCustomer(record.phone)} >
                            {record.phone}
                        </Button>
                        <div>
                            {record.full_name}
                        </div>
                    </Space>
                )

            }
        },

        {
            title: 'Còn nợ',
            sorter: (a, b) => a.debt?.current_debt - b.debt?.current_debt,
            render: (record) => {
                return (
                    <Space direction='vertical'>
                        <div>
                            {formatCurrency(record.debt?.current_debt)}
                        </div>

                    </Space>
                )


            }
        },

        {
            title: 'Ngày nợ',
            sorter: (a, b) => moment(a.debt.last_debt).isBefore(moment(b.debt.last_debt)),
            render: (record) => {
                return (
                    <Space direction='vertical'>
                        <div>
                            {moment(record.debt.last_debt).format("DD/MM/YY")}
                        </div>

                    </Space>
                )


            }
        },


        {
            title: 'Thanh toán gần nhất',
            sorter: (a, b) => a.stats?.total_spend - b.stats?.total_spend,
            render: (record) => {
                return (
                    <Space direction='vertical'>
                        <div>
                            {record.debt.last_payment_date &&
                                <>
                                    {moment(record.debt.last_payment_date).format("DD/MM/YY")}
                                </>

                            }


                        </div>
                        <div>
                            {formatCurrency(record.debt?.last_payment_amount)}
                        </div>

                    </Space>
                )


            }
        },





       





    ];

    return (
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
            <Card style={{ width: "100%" }}>
                <Space direction='vertical' style={{ width: "100%" }}>


                    <Search
                        placeholder="Số điện thoại hoặc tên"
                        onSearch={onSearch}
                        onChange={e => setFilterValue("info", e.target.value)}
                        style={{
                            width: "100%",
                        }}
                    />

                    <Divider></Divider>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Statistic title="Tổng số khách hàng" value={data.length} />
                        </Col>
                        <Col span={12}>
                            <Statistic title="Tổng số nợ" value={_.sumBy(data, x => x.debt?.current_debt ?? 0)} precision={0} />

                        </Col>

                    </Row>

                    <Flex justify='flex-end' style={{ width: "100%" }}>
                        <Space>

                            <AddPayment onSaved={onSaved}></AddPayment>
                            <AddDebt onSaved={onSaved}></AddDebt>
                        </Space>

                    </Flex>
                </Space>


            </Card>
            <Card style={{ width: "100%" }}>
                <Table dataSource={data} columns={columns} />
            </Card>
             <CustomerInfoModal phone={clickPhone} open={showCustomerInfo} onClose={e => setShowCustomerInfo(false)}></CustomerInfoModal>
        </Space>
    )
}

export default OrderList;
